<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('saleAgentByCategory.header') }}
        </div>

        <sale-agent-by-category-list-view
            class="saleAgentByCategoryListView"
            :saleAgents="agentlist"
            :pagination="pagination"/>

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import SaleAgentByCategoryListView from '@/views/SaleAgentByCategoryListView'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentByCategoryListPage',

    components: {
        SaleAgentByCategoryListView
    },

    data () {
        return {
            saleAgents: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 1,
                itemsPerPage: 50,
                search: '',
                type: 'ทุกประเภทตัวแทน',
                status: 'active'
            }
        }
    },

    computed: {
        ...mapState('saleagentList', ['agentlist'])
    },

    mounted () {
        this.getSaleAgentList()
    },

    methods: {
        getSaleAgentList () {
            this.$store.dispatch('saleagentList/fetchAgentlist')
                .then((e) => {
                    this.pagination.pageTotal = e
                    this.pagination.pageTotalVisible = e
                    console.log('this.pagination.pageTotal' + e)
                })
        },

        onPaginationChanged (e) {
            this.pagination.page = e
            this.$store.commit('saleagentList/setPage', e - 1)
            this.$store.dispatch('saleagentList/fetchAgentlist')
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
